import React from 'react';

interface SpotlightStarIconProps {
  size?: number;
  strokeWidth?: number;
  color?: string;
  className?: string;
}

/**
 * SpotlightStarIcon - Featured Spotlight icon
 * - 24x24 grid
 * - strokeWidth: 1.5
 * - Rounded linecaps
 * - No fills
 */
export const SpotlightStarIcon: React.FC<SpotlightStarIconProps> = ({
  size = 24,
  strokeWidth = 1.5,
  color = 'currentColor',
  className = '',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  );
};





























